import { render } from "./StrokedTickIcon.vue?vue&type=template&id=097e0283"
import script from "./StrokedTickIcon.vue?vue&type=script&lang=js"
export * from "./StrokedTickIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__